export default __webpack_public_path__ + "59b6c17bb8ddb31589d26f4eb6097ffe.png";